let common = {
    error: 'The application does not exist. Please check whether the application link is correct',
    code501: 'Access restriction',
    success:"Operation successfully!",
    failed: "Operation failed!",
    addSuccess: "Added successfully!",
    updateSuccess: "Modified successfully!",
    deleteSuccess: "Deleted successfully!",
    exportSuccess: "Export Success!",
    addFailed: "Failed to add!",
    updateFailed: "Failed to modify!",
    deleteFailed: "Failed to delete!",
    spin: {
        text: 'Loading...',
    },
	push: {
		text: "Push",
		sendCode: "Send"
	},
	code: {
        verifyCode: "Verification code",
        get: "Get code",
		msg6: "Please enter a 6-digit verification code",
		enterCode: "Please enter the verification code",
	},
	btn: {
		ok: "OK",
		search: "Search",
		reset: "Reset",
        default: "Restore default",
        add: 'Add',
		edit: "Edit",
        update: "Update",
        delete: "Delete",
        deleteAll: "Delete All",
        batchDelete: "Batch Delete",
		save: "OK",
		cancel: "Cancel",
        back: 'Back',
		close: "Close",
		loading:"Loading.....",
		commit:"Submit",
        lock:"Lock",
        unlock:"Unlock",
        bind: 'Bind',
        unbind: 'Unbind',
        upload: 'Upload',
        export: 'Export',
	},    
    operation: "Actions",
    lock: {
        lockStatus: 'Lock Status',
        locked: 'Locked',
        unlocked: 'Unlocked',
        confirmLockCheckedData: 'Confirm locked {name}?',
        confirmUnlockCheckedData: 'Confirm unlocking {name}?',
    },
    pwd: {
        password: 'Password',
        enterPassword: 'Please enter the password',
        confirmPassword: 'Confirm Password',
        enterConfirmPassword: 'Please enter a confirmation password',
        oldPassword: 'Old Password',
        enterOldPassword: 'Please enter the old password',
        newPassword: 'New Password',
        enterNewPassword: 'Please enter a new password',
        passwordNotMatch: 'The entered passwords are inconsistent',
        passwordInvalid: 'The length of the password is 6-24 digits, please confirm the length of the password!'
    },
    browser: {
        errorAuthentication: 'Your browser does not support this authentication mode!',
        arouse: 'The authenticator has been invoked!',
        overtime: 'The user canceled the operation or timed out!',
        noWeb: 'This browser does not support Web authentication!',
        secureConnection: 'Web authentication supports only secure connections',
        authenticationMethod: 'Please select an authentication method!',
        FIDO2Look: 'FIDO2 authentication login failed: authenticator locked',
        FIDO2Err: 'FIDO2 authentication login failed: authenticator not enabled',
        nonsupport: 'Your browser does not currently support binding tokens!',
    },
    pagination: {
        from: 'From',
        to: 'To',
        aggregate: 'Total',
        strip: 'Strip',
        perPage: 'Per page',
    },
    tailorImg: {
        title: 'Avatar upload',
        uploadText: 'Select Image',
        typeErr: 'Please upload JPG and PNG images!',
        sizeErr: 'Images cannot be larger than 200kb!',
        noFile: 'Please choose a picture!',
    },
    header: {
        goOut: 'Sign out',
        modalTitle: 'Session is about to time out reminder',
        okText: 'Continue to use',
        countdown: 'Current remaining session duration',
        notification: 'Notification',
        tip1: 'You have',
        tip2: 'Messages not viewed',
    },
        status: 'Status',
    normal: 'Normal',
    notActive: 'Inactive',
    createTime: 'Create Time',
    importTime: 'Import Time',
    bindTime: 'Bind Time',
    descp: 'Description',
    descpMaxLength: "The maximum description length is 255 characters",
    noSpacesAllowedBothEnds: "No spaces allowed at both ends",
    nameFormat: "The name has a length of 1-64 and supports Chinese characters, letters, numbers, spaces, _-",
    nameFormat32: "The name has a length of 1-32 and supports Chinese characters, letters, numbers, spaces, _-",
    selFile: "Upload File",
    uploadFile: "Upload file",
    clickOrDragFile: "Click or drag files here",
    fileIsEmpty: "Please select the file",
    fileName: "File Name",
    fileSize: "File Size",
    fileTypeUnsupported: "File type unsupported, pelase upload {type}",
    fileTooLarge: "File too large, the maximum size is {size}",
    none: "None",
    selType: "Please select type",
    confirmDeleteCheckedData: 'Delete task {name}?',
    confirmUnbindCheckedData: 'Unbind {name}?',
    cancelRelease: "Cancel this task {name}?",
    settings:{
		session_expire_time: "Login session validity period",
		login_failed_limit: "Login failure retry limit",
		account_lock_time: "Login Failure Exceeded Lockout Time",
		session_30m: "30 minutes",
		session_60m: "60 minutes",
		session_120m: "2 hours",
		session_12h: "12 hours",
		session_24h: "24 hours",
		lock_10m: "10 minutes",
		lock_30m: "30 minutes",
		lock_60m: "1 hours",
		lock_120m: "2 hours",
		lock_12h: "12 hours",
		lock_24h: "24 hours"
	}

}

export default common
